import React from 'react';

import { Box, HStack, Image, VStack } from '@chakra-ui/react';

import * as images from '../images';
import SignUpButton from './SignUpButton';
import { TopPageVariant } from './types';
import HeaderContent from './HeaderContent';

const bgImages = {
  normal: {
    base: images.headingNormalSp,
    sm: images.headingNormalPc,
  },
  intern: {
    base: images.headingInternSp,
    sm: images.headingInternPc,
  },
  interview: {
    base: images.headingNormalSp,
    sm: images.headingNormalPc,
  },
};

const logoImages = {
  normal: images.rikeimatchLogo,
  intern: images.rikeimatchLogoWhite,
  interview: images.rikeimatchLogo,
};

type PropsType = {
  variant: TopPageVariant;
  scrollToForm: () => void;
};

const TopHeader = ({ variant, scrollToForm }: PropsType): JSX.Element => (
  <Box
    as="header"
    bgImg={bgImages[variant]}
    bgPos="center center"
    bgSize="cover"
    bgRepeat="no-repeat"
    paddingBottom="60px"
  >
    <Box margin="auto" maxW="1000px">
      <Box maxW="480px" padding="50px 0" textAlign="center">
        <HStack justifyContent="center" paddingBottom="10px">
          <Image src={logoImages[variant]} w="205px" alt="" />
        </HStack>
        <HeaderContent variant={variant} />
        <VStack
          w="100%"
          alignItems="center"
          display={{ base: 'none', sm: 'inherit' }}
        >
          <SignUpButton variant={variant} onClick={() => scrollToForm()} />
        </VStack>
      </Box>
    </Box>
    <VStack
      w="100%"
      alignItems="center"
      paddingTop="140px"
      display={{ base: 'inherit', sm: 'none' }}
    >
      <SignUpButton variant={variant} onClick={() => scrollToForm()} />
    </VStack>
  </Box>
);

export default TopHeader;
